// extracted by mini-css-extract-plugin
export default {"wrapperMobile":"XRABuXbj49iQmtDapl4X"};